import { useEffect, useRef } from 'react';
import type { EChartsReactProps } from 'echarts-for-react';
import ReactEChartsCore from 'echarts-for-react';
// oxlint-disable-next-line import/no-namespace
import * as echarts from 'echarts/core';
import { merge } from 'lodash';

import { defaultChartTheme } from './theme';

type Props = EChartsReactProps;

export function Chart(props: Props) {
  const { theme, option, ...restProps } = props;
  const mergedTheme = merge({}, defaultChartTheme, theme);

  const chartRef = useRef<ReactEChartsCore>(null);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (chartRef.current) {
        chartRef.current.getEchartsInstance().resize();
      }
    });

    if (chartRef.current) {
      const element = chartRef.current.ele;
      if (element.parentElement) {
        resizeObserver.observe(element.parentElement);
      }
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <ReactEChartsCore
      echarts={echarts}
      ref={chartRef}
      option={option}
      theme={mergedTheme}
      opts={{ renderer: 'svg' }}
      {...restProps}
    />
  );
}
